/**
 * Calculates area overlap of two rectangles,
 *
 * ### Example (es module)
 * ```js
 * import getDirections from 'calculate-position'
 *
 * const rectA = {
 *  width: 100,
 *  height: 100,
 *  left: 0,
 *  top: 0
 * }
 *
 * const rectB = {
 *  width: 50,
 *  height: 50,
 *  left: 0,
 *  top: 0
 * }
 *
 * console.log(getRectangleOverlap(rectA, rectB)
 * // => 2500
 * ```
 *
 * @param anchor - anchor position that calculations will be based of
 * @param dimensions - width/height dimensions of popup element
 */
export const getRectangleOverlap = (rectangleA, rectangleB) => {
    const xOverlap = Math.max(0, Math.min(rectangleA.left + rectangleA.width, rectangleB.left + rectangleB.width) - Math.max(rectangleA.left, rectangleB.left));
    const yOverlap = Math.max(0, Math.min(rectangleA.top + rectangleA.height, rectangleB.top + rectangleB.height) - Math.max(rectangleA.top, rectangleB.top));
    return xOverlap * yOverlap;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVjdGFuZ2xlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9yZWN0YW5nbGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztHQTJCRztBQUNILE1BQU0sQ0FBQyxNQUFNLG1CQUFtQixHQUFHLENBQ2pDLFVBQXFCLEVBQ3JCLFVBQXFCLEVBQ3JCLEVBQUU7SUFDRixNQUFNLFFBQVEsR0FBRyxJQUFJLENBQUMsR0FBRyxDQUN2QixDQUFDLEVBQ0QsSUFBSSxDQUFDLEdBQUcsQ0FDTixVQUFVLENBQUMsSUFBSSxHQUFHLFVBQVUsQ0FBQyxLQUFLLEVBQ2xDLFVBQVUsQ0FBQyxJQUFJLEdBQUcsVUFBVSxDQUFDLEtBQUssQ0FDbkMsR0FBRyxJQUFJLENBQUMsR0FBRyxDQUFDLFVBQVUsQ0FBQyxJQUFJLEVBQUUsVUFBVSxDQUFDLElBQUksQ0FBQyxDQUMvQyxDQUFDO0lBRUYsTUFBTSxRQUFRLEdBQUcsSUFBSSxDQUFDLEdBQUcsQ0FDdkIsQ0FBQyxFQUNELElBQUksQ0FBQyxHQUFHLENBQ04sVUFBVSxDQUFDLEdBQUcsR0FBRyxVQUFVLENBQUMsTUFBTSxFQUNsQyxVQUFVLENBQUMsR0FBRyxHQUFHLFVBQVUsQ0FBQyxNQUFNLENBQ25DLEdBQUcsSUFBSSxDQUFDLEdBQUcsQ0FBQyxVQUFVLENBQUMsR0FBRyxFQUFFLFVBQVUsQ0FBQyxHQUFHLENBQUMsQ0FDN0MsQ0FBQztJQUVGLE9BQU8sUUFBUSxHQUFHLFFBQVEsQ0FBQztBQUM3QixDQUFDLENBQUMifQ==